import { createAsyncThunk } from '@reduxjs/toolkit';

import { onResultWithDataStatus } from 'Shared/HttpServices/Utils/utils';

import { MosaferatiApiPaths } from '../Constant/MosaferatiApiPaths';
import { MosaferatiHttpGetService, MosaferatiHttpPostService } from '../Services/MosaferatiHttpService';

export const createShenasehPardakht = createAsyncThunk('createShenasehPardakht', async (command: any) => {
  return await MosaferatiHttpPostService({
    url: `${MosaferatiApiPaths.BimehNameh.CreateShenasehPardakht}`,
    body: command,
    onResult: onResultWithDataStatus,
  });
});
export const getMosaferatiShomarehBimehNamehHa = createAsyncThunk(
  'MosaferatiBimehNamehHa/GetMosaferatiShomarehBimehNamehHa',
  async () => {
    return await MosaferatiHttpGetService({
      url: `${MosaferatiApiPaths.BimehNameh.GetMosaferatiShomarehBimehNamehHa}`,
    });
  }
);

export const printBimehNamehMosaferati = createAsyncThunk(
  'MosaferatiPrint/printBimehNamehMosaferati',
  async (query: any) => {
    return await MosaferatiHttpGetService({
      url: `${MosaferatiApiPaths.BimehNameh.PrintBimehNamehMosaferati}`,
      params: query,
      responseType: 'blob',
      isFile: true,
    });
  }
);

export const bimehNamehMosaferatiSaderShodeh = createAsyncThunk(
  'ParvandehKhesarat/checkBimehNamehMosaferatiStatus',
  async (query: any) => {
    return await MosaferatiHttpGetService({
      url: `${MosaferatiApiPaths.BimehNameh.BimehNamehMosaferatiSaderShodeh}`,
      params: query,
    });
  }
);

export const getNerkhNoeGharardadSafarByNoeGharardadSafarCoreId = createAsyncThunk(
  'Mosaferati/getNerkhNoeGharardadSafarByNoeGharardadSafarCoreId',
  async (query: any) => {
    return await MosaferatiHttpGetService({
      url: `${MosaferatiApiPaths.NoeGharardadSafar.GetNerkhNoeGharardadSafarByNoeGharardadSafarCoreId}`,
      params: query,
    });
  }
);
